// extracted by mini-css-extract-plugin
export var modal = "_bx-0";